import Resource from '@/services/resources/common';

export default class ActionResource extends Resource {
  constructor(entrypoint = '/actions', alias = 'Action') {
    super(entrypoint, alias);
  }
}
